module.exports = __webpack_public_path__ + "img/Elektrische rolstoel.ff69f224.svg";